import { Text } from '@thefarmersfront/kitchen';

import CollectingRequestCollectingInfoForm from './CollectingRequestCollectingInfoForm';
import CollectingRequestOriginalOrderInfo from './CollectingRequestOriginalOrderInfo';
import type useCollectingRequestRegisterForm from './useCollectingRequestRegisterForm';

import type { CollectingOutboundDetail, CollectingRequestRegisterOptions } from '~/types/delivery-agency.types';

import styles from './CollectingRequestRegisterModal.module.scss';

const ALIM_TALK_INFO = '주간 시간대에 등록 시(07시~22시) 등록 완료 직후 고객에게 방문 예정 알림톡이 발송됩니다.';

const CollectingRequestRegisterStep2 = ({
  detail,
  options,
  form,
  onSearchAddress,
  onResetCollectingInfo,
}: {
  detail: CollectingOutboundDetail;
  options: CollectingRequestRegisterOptions;
  form: ReturnType<typeof useCollectingRequestRegisterForm>;
  onSearchAddress: (primaryAddress: string) => void;
  onResetCollectingInfo: () => void;
}) => {
  return (
    <>
      <div className={styles['guide-banner']}>
        <Text className={styles['guide-banner-text']} size="large" color="kurly" element="p">
          {ALIM_TALK_INFO}
        </Text>
      </div>
      <div className={styles['step2-container']}>
        <CollectingRequestOriginalOrderInfo detail={detail} />
        <CollectingRequestCollectingInfoForm
          receiverName={detail.receiverName}
          options={options}
          form={form}
          onSearchAddress={onSearchAddress}
          onReset={onResetCollectingInfo}
        />
      </div>
    </>
  );
};

export default CollectingRequestRegisterStep2;
